export enum LoaderMode {
    Blur,
    Solid
}